<template>
  <div>
    <router-view></router-view>
    <div class="sub-header">
      <div class="width-wrapper relative">
        <div class="page-title">Сотрудники</div>


        <div class="header__save" >
        <span  v-if="$store.state.user.role == 'HM'">
          <router-link  title="" :to="{ path: `/users/add/` }" class="button button--inverse">Добавить пользователя</router-link>
          </span>
        </div>
      </div>



    </div>



    <div class="reports-list">

      <div class="reports-list-head">
        <div class="report-item report-item--head report-item__pharmacy">Аптека</div>
        <div class="report-item report-item--head report-item__email">Почта</div>
        <div class="report-item report-item--head report-item__name">Имя</div>
      </div>

      <div class="reports-list-body">

        <div v-for="user in users" class="report-item-line" @click="$router.push(`${user.id}/`)">
          <div class="report-item report-item__pharmacy">{{user.pharmacy != null ? user.pharmacy.title : ''}}</div>
          <div class="report-item report-item__email">{{user.email}}</div>
          <div class="report-item report-item__name">{{user.firstName}}<br>{{user.lastName}}</div>

        </div>
      </div>

    </div>








      </div>
</template>


<script>
  import axios from 'axios';

  export default {
    name: 'reports',
    created() {
      this.loadVersions();
    },
    methods: {
      loadVersions() {
        const self = this;
        axios.get('/api/v2/users/?role=PM').then((response) => {
          self.isLoading = false;
          self.users = response.data;
        });
      },
      save() {

      },
    },
    data() {
      return {
        users: [],
      };
    },
  };

</script>


<style type="text/css" scoped="true" lang="less">

  .reports-list{
    width: 705px;
    box-sizing: border-box;
    background: #FFFFFF;
    border:1px solid #DFE4E8;
    margin: 30px auto;
    font-size: 0;
    border-radius:  4px;
    overflow: hidden;

  }
  .reports-list-head{
    border-bottom: 2px solid #E4E4E4;

  }

  .report-item-line{
    &:hover{
        background: #E4E4E4;
      cursor: pointer;
    }
  }

  .report-item{
    vertical-align: top;
    height: 38px;
    padding-top: 16px;
    display: inline-block;
    font-size: 12px;
    margin: 21px 21px;

    &--head{
      margin-bottom: 20px;
      margin-top: 0 !important;
      text-align: left !important;
    }

    &__name {
      width: 150px;
    }

    &__email {
      width: 150px;
    }

    &__pharmacy{
      width: 100px;
    }


  }

</style>


// WEBPACK FOOTER //
// Users.vue?57ee2aed